import { Routes } from '@angular/router';

import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

import { validateGameshowExists } from './game-show-gameplay/game-show-guard';

export const GAME_SHOW_ROUTE = {
  name: 'game-show',
  route(classId: string): string[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), GAME_SHOW_ROUTE.name];
  },
  DEFAULT: '',

  JOIN: {
    name: 'join',
    route(classId: string): string[] {
      return [...GAME_SHOW_ROUTE.route(classId), GAME_SHOW_ROUTE.JOIN.name];
    }
  },
  SURVEY: {
    name: 'survey',
    route(classId: string, activityId: string): string[] {
      return [...GAME_SHOW_ROUTE.route(classId), activityId, GAME_SHOW_ROUTE.SURVEY.name];
    }
  },
  GAMEPLAY: {
    name: 'gameplay',
    route(classId: string, activityId: string): string[] {
      return [...GAME_SHOW_ROUTE.route(classId), activityId, GAME_SHOW_ROUTE.GAMEPLAY.name];
    }
  }
};

export const GAME_SHOW_ROUTES: Routes = [
  {
    path: GAME_SHOW_ROUTE.JOIN.name,
    loadComponent: () => import('app/student/game-show/waiting-to-join/waiting-to-join.component').then((m) => m.WaitingToJoinComponent),
    data: {
      hideStudentTopNavigation: true,
      hideStudentCountersBar: true
    }
  },
  {
    path: `:activityId/${GAME_SHOW_ROUTE.GAMEPLAY.name}`,
    canActivate: [validateGameshowExists],
    loadComponent: () => import('app/student/game-show/game-show-gameplay/game-show-gameplay.component').then((m) => m.GameShowStudentGameplay),
    data: {
      hideStudentTopNavigation: true,
      hideStudentCountersBar: true
    }
  }
];
